<template>
  <div class="liu">
    <!-- title -->
    <mt-header fixed title="任务奖励汇总" class="title1">
      <mt-button slot="left" icon="back" @click="$router.go(-1)">返回</mt-button>
      <mt-button slot="right" @click="visible.search = true">更多</mt-button>
    </mt-header>
    <div class="scroll-container" :style="customScrollHeight" v-infinite-scroll="getMoreMyData" :infinite-scroll-disabled="myData.scrollDisabled" infinite-scroll-distance="0">
      <!-- 提示行 -->
      <!-- 如果有tips提示信息，此div样式要用class="tips-box" -->
      <!-- <div /> -->
      <!-- 空页 -->
      <div v-if="isEmptyData"></div>
      <!-- 任务列表 -->
      <div v-if="isHasData">
        <div class="agent-info-box" v-for="(item, index) in myData.list" :key="index" @click="onRowClick(item.rewardDate)">
          <div class="agent-info">
            <div class="cell-bottom">奖励金额(元)：</div>
            <div class="cell-bottom theme-color">{{ item.rewardMoney | num }}</div>
            <span class="agent-date">{{ item.rewardDate }}</span>
          </div>
        </div>
      </div>

      <!-- 无数据占位图 -->
      <div v-if="isNoData">
        <div class="no-data">
          <img src="../../assets/bitmap_reward@3x.png" width="60%" />
          <div class="title-5" v-if="myParam.productAgentId">暂无数据</div>
          <div class="title-5" v-else>{{ emptyStartDate + " - " + emptyEndDate + " 暂无奖励" }}</div>
          <div class="title-5"> 点击右上角 <span @click="visible.search = true">更多</span> 查看更多 </div>
        </div>
      </div>
    </div>
    <!-- 查询弹出框 -->
    <mt-popup class="agent-popup" v-model="visible.search" position="right" :modal="false">
      <div class="agent-content">
        <!-- 标题 -->
        <mt-header fixed title="筛选" class="title2"></mt-header>
        <!-- 内容 -->
        <div class="popup-content">
          <!-- 奖励时间 -->
          <div class="content-box">
            <div>
              <span>状态</span>
            </div>
            <div class="clearfix">
              <span type="default" class="star" :class="{ 'select-star': myParam.rewardType===item.value }" v-for="(item, index) in search.status.list" :key="index" @click="myParam.rewardType=item.value">
                {{ item.name }}
              </span>
            </div>
          </div>
          <div class="content-box">
            <div>
              <span>奖励时间</span>
            </div>
            <div class="no-border">
              <span class="date" @click="onSearchDateClick('startDate')">{{ picker.startDateText }}</span>
              -
              <span class="date" @click="onSearchDateClick('endDate')">{{ picker.endDateText }}</span>
            </div>
          </div>
        </div>
        <!-- 按钮 -->
        <div class="more-button">
          <span class="white" @click="onSearchCancelClick">取消</span>
          <span class="blue" @click="onSearchOkClick">确定</span>
        </div>
      </div>
    </mt-popup>
    <!-- 代理商名称-筛选页面 -->
    <mt-popup class="search-popup" v-model="visible.agent" position="right" :modal="false">
      <mt-header fixed title="选择代理商" class="title2">
        <mt-button slot="left" icon="back" @click="visible.agent = false">返回</mt-button>
      </mt-header>
      <div>
        <form action="" v-on:submit.prevent="">
          <mt-search v-model="search.agent.key" @keyup.enter.native="onAgentTableSearchClick" cancel-text="取消" placeholder="输入代理商姓名或手机号" :show="true">
            <div class="result-list">
              <div class="list-row">
                <div class="list-item" v-for="(item, index) in search.agent.list" :key="index" @click="onAgentTableSelectedClick(item)">
                  <span>{{ item.name + " " + item.mobile }}</span>
                </div>
              </div>
            </div>
          </mt-search>
        </form>
      </div>
    </mt-popup>
    <!-- 日期控件 -->
    <mt-datetime-picker ref="datePicker" type="date" :value="picker.selectedDate" :startDate="picker.startDate" :endDate="picker.endDate" year-format="{value} 年" month-format="{value} 月" date-format="{value} 日" @confirm="onDatePickerConfirm" />
  </div>
</template>

<script>
import { DateBase, GetAgentListBox, ShowTaskRewardLogList } from '@/api/agent';
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';
import { CusToast, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';
import { formatDate } from '@/utils/utils';

export default {
  name: 'TaskRewardSettingSum',
  data() {
    return {
      product: PUBLIC_PRODUCT.toLowerCase().trim() /*global PUBLIC_PRODUCT*/,
      // 列表信息
      myData: {
        list: [],
        total: -1,
        scrollDisabled: true,
      },
      // 查询参数
      myParam: {
        pageNum: 1,
        pageSize: 6,
        startDate: '',
        endDate: '',
        rewardType: -1,
        agentId: '',
      },
      // picker时间
      picker: {
        startDateBase: '',
        endDateBase: '',
        startDateText: '',
        endDateText: '',
        startDate: new Date(),
        endDate: new Date(),
        selectedDate: null,
        dateType: '',
      },
      // 查询数据
      search: {
        // 代理商名
        agent: {
          list: [],
          key: '',
          selected: '',
          empty: true,
        },
        status: {
          list: [
            { name: '全部', value: -1 },
            { name: '激活奖励', value: 1 },
            { name: '达标奖励', value: 2 },
            { name: '优质商户', value: 3 },
            { name: '小微达标', value: 4 },
            { name: '码牌(音箱)达标奖励', value: 5 },
            { name: '码牌(音箱)优质商户奖励', value: 6 },
          ],
        },
      },
      // 显示开关
      visible: {
        search: false,
        agent: false,
      },
      slots: [
        {
          value: -1,
          text: '全部',
        },
        {
          value: 1,
          text: '激活奖励',
        },
        {
          value: 2,
          text: '达标奖励',
        },
        {
          value: 3,
          text: '优质商户',
        },
      ],
    };
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'taskrewardsettingsum') {
      this.$store.commit('setCache', 'settingsum');
    } else {
      this.$store.commit('delCache', 'settingsum');
    }
    next();
  },
  mounted() {
    this.initData();
  },
  computed: {
    emptyStartDate() {
      return this.picker.startDateText.replace(/\-/g, '.');
    },
    emptyEndDate() {
      return this.picker.endDateText.replace(/\-/g, '.');
    },
    isEmptyData() {
      return this.myData.total === -1;
    },
    isHasData() {
      return this.myData.total > 0;
    },
    isNoData() {
      return this.myData.total === 0;
    },
    customScrollHeight() {
      return `height:${window.innerHeight}px;`;
    },
  },
  methods: {
    // 加载数据
    initData() {
      // 滚动条置顶
      window.scrollTo(0, 0);
      // 列表清空
      this.myData.list = [];
      // 加载数据
      this.$nextTick(() => {
        this.getDateBase(this.getMyData);
        // this.getMyData();
      });
    },
    // 通过接口获取数据
    getMyData() {
      CusLoadingOpen();
      // 先设置禁止滚动加载数据
      this.myData.scrollDisabled = true;
      // 判断是否选了下级代理商
      // 如果没选下级代理商，表示有日期范围，按日期范围查询
      // 如果没选下级代理商，没有日期范围，查询全部日期
      this.myParam.startDate = `${this.picker.startDateText} 00:00:00`;
      this.myParam.endDate = `${this.picker.endDateText} 23:59:59`;
      this.myParam.agentId = `${this.$route.query.agentid ? this.$route.query.agentid : ''}`;
      ShowTaskRewardLogList(this.myParam)
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.myData.total = res.total;
              this.myData.list.push(...res.rows);
              // 通过记录条数list.length和数据总数total判断是否查询出所有数据
              // 如果记录条数小于数据总数，则证明没有查询出所有数据，设置允许滚动加载数据
              if (this.myData.list.length < this.myData.total) {
                this.myData.scrollDisabled = false;
              }
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          this.myData.list = [];
          this.myData.total = 0;
          this.myData.scrollDisabled = true;
          this.myParam.pageNum = 1;
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 自动加载获取更多数据
    getMoreMyData() {
      // 通过记录条数list.length和数据总数total判断是否查询出所有数据
      // 如果记录条数小于数据总数，则证明没有查询出所有数据，让页数加1并继续获取数据
      if (this.myData.list.length < this.myData.total) {
        this.myParam.pageNum += 1;
        this.getMyData();
      }
    },
    // 交互后返回代理商列表
    getAgentListBox(nameOrMobile = '', callback = null) {
      CusLoadingOpen();
      const agentFindType = 1;
      GetAgentListBox({ agentFindType, nameOrMobile })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.search.agent.list = res.rows;
              document.activeElement.blur();
              callback && callback();
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 交互后返回日期查询条件
    getDateBase(callback = null) {
      DateBase({ interfaceName: '/app/Agent/ShowTaskRewardLogList' })
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.picker.startDateBase = res.data.startDate.split(' ')[0];
              this.picker.endDateBase = res.data.endDate.split(' ')[0];
              this.picker.startDateText = this.picker.startDateBase;
              this.picker.endDateText = this.picker.endDateBase;
              callback && callback();
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 查询搜索取消事件
    onSearchCancelClick() {
      this.visible.search = false;
      this.clearSearchData();
    },
    // 查询搜索单击事件
    onSearchOkClick() {
      // 滚动条置顶
      window.scrollTo(0, 0);
      // 1.关闭查询窗口
      this.visible.search = false;
      // 2.打开滚动刷新
      this.myData.scrollDisabled = true;
      // 3.重置列表数据
      this.myData.list = [];
      // 4.重置翻页页数
      this.myParam.pageNum = 1;
      // 5.重置总数
      this.myData.total = -1;
      // 6. 加载数据
      this.getMyData();
    },
    // 单击日期事件
    onSearchDateClick(val) {
      // 设置日期类型
      this.picker.dateType = val;
      // 根据选择的日期类型判断
      switch (val) {
        // 开始日期
        case 'startDate':
          // 日期框显示的最大日期：2000-01-01
          this.picker.startDate = new Date('2000-01-01');
          // 日期框显示的最小日期：今天
          this.picker.endDate = new Date();
          // 日期框显示的选中日期：默认查询开始日期
          this.picker.selectedDate = new Date(this.picker.startDateText);
          break;
        // 结束日期
        case 'endDate':
          // 日期框显示的最大日期：默认查询开始日期
          this.picker.startDate = new Date(this.picker.startDateText);
          // 日期框显示的最小日期：今天
          this.picker.endDate = new Date();
          // 日期框显示的选中日期：默认查询结束日期
          this.picker.selectedDate = new Date(this.picker.endDateText);
          break;
      }
      this.$refs.datePicker.open();
    },
    // 返回按钮事件
    onGoBackClick() {
      window.location.href = 'protocol://android';
    },
    // 行单击事件
    onRowClick(date) {
      this.$router.push({
        path: '/taskrewardsettingdetail',
        query: { date, agentid: this.$route.query.agentid ? this.$route.query.agentid : '' },
      });
    },
    // 日期确定事件
    onDatePickerConfirm(val) {
      // 根据选择的日期类型判断
      switch (this.picker.dateType) {
        // 开始日期
        case 'startDate':
          // 如果开始日期选择了一个大于当前查询结束日期
          if (val > new Date(this.picker.endDateText)) {
            // 则将查询结束日期自动置为今天的日期
            this.picker.endDateText = formatDate(new Date());
          }
          this.picker.startDateText = formatDate(val);
          break;
        // 结束日期
        case 'endDate':
          this.picker.endDateText = formatDate(val);
          break;
      }
    },
    // 筛选窗口代理商名称点击事件
    onAgentTextClick() {
      this.getAgentListBox('', () => {
        this.visible.agent = true;
        this.search.agent.key = '';
      });
    },
    // 清空筛选框中代理商名称的事件
    onAgentClearBtnClick() {
      this.search.agent.selected = '';
      this.myParam.productAgentId = '';
      this.search.agent.empty = true;
    },
    // 代理商名称列表商户名称查询事件
    onAgentTableSearchClick() {
      this.getAgentListBox(this.search.agent.key);
    },
    // 代理商列表选中商户名称事件
    onAgentTableSelectedClick(item) {
      this.search.agent.selected = `${item.name} ${item.mobile}`;
      this.myParam.productAgentId = item.productAgentId;
      this.search.agent.empty = false;
      this.visible.agent = false;
    },
    // 置空所有筛选窗口数据
    clearSearchData() {
      this.search.agent.empty = true;
      this.picker.startDateText = this.picker.startDateBase;
      this.picker.endDateText = this.picker.endDateBase;
    },
  },
  filters: {
    num(val) {
      const valStr = val.toString();
      if (valStr.length < 3) {
        return `0.${val.toString().substr(-2)}`;
      } else {
        return `${val.toString().substring(0, val.toString().length - 2)}.${val.toString().substr(-2)}`;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.agent-info-box {
  &:nth-child(2) {
    margin-top: 0.75rem !important;
    background-color: #fff;
  }
}
</style>
